<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card light id="bill" v-if="bills">
        <!-- <v-progress-linear height="5" :loading="true"></v-progress-linear> -->

        <v-card-text style="text-align:center" v-if="!loading &&  (bills.c_list && bills.c_list.length<=0 )">
          <h3>Class has no students.</h3>
        </v-card-text>
        <v-card-text style="text-align:center" v-if="loading">
          <v-progress-circular
            :indeterminate="true"
            :rotate="0"
            :size="68"
            :value="''"
            :width="3"
            color="light-blue"
          >{{ 'loading...' }}</v-progress-circular>
        </v-card-text>
        <v-card-text
          v-for="(bill,idx) in bills.c_list"
          :key="idx"
          style="page-break-after: always;"
          v-if="!loading && bills"
        >
          <v-layout row wrap>
            <v-flex xs12 style="text-align:center">
              <h2 style="font-weight:bold">CAREER BUILDERS ACADEMY - BOGOSO</h2>
              <h4 style="font-style:italic">(MOTTO: DILIGENCE AND SELF DISCIPLINE)</h4>
              <p>PUPIL'S BILL</p>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card flat>
                    <v-card-text>
                      <v-layout row>
                        <v-flex xs9>
                          <p>
                            <span style="font-weight:bold">PUPIL'S NAME:</span>
                            {{bill.s_bio&&bill.s_bio.name?bill.s_bio.name:""}}
                          </p>
                        </v-flex>
                        <v-flex xs3>
                          <p>
                            <span style="font-weight:bold">NO. ROLL:</span>
                            {{bill.rollno}}
                          </p>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs6>
                          <p>
                            <span style="font-weight:bold">CLASS/FORM:</span>
                            {{bills.c_bill.name}}
                          </p>
                        </v-flex>
                        <v-flex xs3>
                          <p>
                            <span style="font-weight:bold">TERM:</span>
                            {{head_data.term}}
                          </p>
                        </v-flex>
                        <v-flex xs3>
                          <p>
                            <span style="font-weight:bold">YEAR:</span>
                            {{head_data.year}}
                          </p>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs12>
                          <p>
                            <span style="font-weight:bold">REF:</span> .................
                          </p>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-card flat>
                    <v-divider></v-divider>
                    <v-card-text>
                      <!-- debits and credits row -->
                      <v-layout row wrap>
                        <v-flex xs12>
                          <!-- credits table -->
                          <v-data-table
                            :headers="bill_headers"
                            :items="bill.s_bill?bill.s_bill.chgs:[]"
                            class="elevation-0"
                            :hide-actions="true"
                            no-data-text="No bill found for class"
                          >
                            <template v-slot:items="props">
                              <td>{{ props.item.charge_item?props.item.charge_item:'' }}</td>
                              <td
                                class="text-xs-center"
                              >{{ props.item.amount?props.item.amount:'' | toCurrency}}</td>
                              <td>{{ props.item.crecharge_item?props.item.crecharge_item:'' }}</td>
                              <td
                                class="text-xs-center"
                              >{{ props.item.creamount?props.item.creamount:'' | toCurrency}}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <!-- bill summary row -->
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card flat>
                        <v-card-text>
                          <v-layout row>
                            <v-flex xs6>
                              <p>
                                <span style="font-weight:bold">Amount Due:</span>
                                {{amtDue(bill.s_bill?bill.s_bill.tot_fee:0,bill.fees_arrears,bill.s_bill?bill.s_bill.tot_disc:0) | toCurrency}}
                              </p>
                            </v-flex>
                            <v-flex xs6>
                              <p>
                                <span style="font-weight:bold">In Words:</span> ..............
                              </p>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs12>
                              <p>
                                <span style="font-weight:bold">NEXT TERM BEGINS:</span>
                                {{ntb}}
                              </p>
                              <p style="text-align:center;margin-left:10px;margin-right:10px">
                                The amount which you have to pay is shown as "Amount Due".
                                <br />Payment must be made on or before the reopening of the term.
                                <br />Failing which your ward will be refused admittance.
                                <br />This bill must be shown when payment is being made.
                              </p>
                            </v-flex>
                          </v-layout>

                          <v-layout row>
                            <v-flex xs6>
                              <p>
                                <span style="font-weight:bold">Date:</span> ..............
                              </p>
                            </v-flex>
                            <v-flex xs6>
                              <p>
                                <span style="font-weight:bold">Accounting Officer:</span> ..............
                              </p>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { calcDiscount } from "../../common/index";
export default {
  props: {
    selected_classb: {
      type: Object
    },
    ntb: {
      type: String
    }
  },
  data() {
    return {
      head_data: {
        term: "",
        year: "",
        work_days: ""
      },
      bill_headers: [
        {
          text: "DEBIT",
          sortable: false,
          value: "sn"
        },
        {
          text: "AMOUNT",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "CREDIT",
          sortable: false,
          value: "status"
        },
        {
          text: "AMOUNT",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      billc_headers: [
        {
          text: "CREDIT",
          sortable: false,
          value: "status"
        },
        {
          text: "AMOUNT",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      bill_data: [
        {
          charge_item: "test",
          amount: "500",
          crecharge_item: "By Scholarship",
          creamount: ""
        },
        {
          crecharge_item: "By Bursary",
          creamount: ""
        },
        {
          crecharge_item: "By Credit",
          creamount: ""
        }
      ]
    };
  },
  created() {
    this.$store.dispatch("settings/getAll");
  },
  computed: {
    ...mapGetters({
      bills: "docs/BILLS",
      errors: "docs/DOC_ERROR",
      loading: "docs/DOC_LOADING",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING"
    })
  },
  methods: {
    // amtDue(chrgs) {
    //   if (chrgs) {
    //     let adue = chrgs.adcharges.reduce((sum, val) => {
    //       return sum + parseFloat(val.amount);
    //     }, 0);

    //     return adue;
    //   } else {
    //     return 0;
    //   }
    // },

    amtDue(tot_fee,arrears,discount) {
      let tf = tot_fee?Number(tot_fee):0
      let ar = arrears? Number(arrears):0
      let dc = discount? Number(discount):0

      let amtdue = (tf+ar) - dc

      return amtdue
    },



  },
  watch: {
    selected_classb(val) {
      if (val) {
        this.$store.dispatch("docs/getBills", { class_id: val.id });
      }
    },
    settings(val) {
      if (val) {
        this.head_data.term = val.ayt.term.name;
        this.head_data.year = val.ayt.acyear.year;
        this.head_data.work_days = val.ayt.term.work_days;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/student/bill.vue